import { Legend } from './legend';
import { LegendDisplay } from './legendDisplay.interface';

export class StackedLegendDisplay implements LegendDisplay {
  public cssClassName = 'legend-display-stacked';

  public displayLegend(
    legends: Array<Legend>,
    setContentFunction: (contentElement: HTMLElement, headerElements?: Array<HTMLElement>) => void,
  ): void {
    const legendDisplayArray = new Array<HTMLElement>();

    legends.forEach((legend: Legend) => {
      const legendDiv = document.createElement('div');
      legendDiv.classList.add('single-legend-wrapper');

      const titleDisplay = legend.createDisplayTitle();
      titleDisplay.classList.add('legend-title');
      legendDiv.appendChild(titleDisplay);

      // call individual legend display function
      const legendDetailsDiv = document.createElement('div');
      legendDetailsDiv.classList.add('legend-details');
      legendDetailsDiv.appendChild(legend.createDisplayContent());
      legendDiv.appendChild(legendDetailsDiv);

      legendDisplayArray.push(legendDiv);
    });

    const contentDiv = document.createElement('div');
    legendDisplayArray.forEach((legendDiv: HTMLElement) => contentDiv.appendChild(legendDiv));

    setContentFunction(contentDiv);
  }
}
